import React from 'react'
import { bool, number } from 'prop-types'
import { css } from '@emotion/react'
import Stars from 'react-stars'

import theme from '@/theme'
import { round } from '@/utils/func'

const ratingWrapperCss = css`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  align-self: start;
`

const summaryCss = css`
  padding-left: 6px;
  padding-right: 4px;
`

const RatingStars = ({
  rate,
  votes,
  size,
  canVote,
  hideSummary,
  starsCount,
  showVotes = true,
}) => {
  const roundedRate = round(rate)

  const showSummary = () => {
    if (!votes) {
      return canVote && '• Be the first one to'
    }

    if (showVotes) {
      return `${rate} • ${votes} ${votes === 1 ? 'Rating' : 'Ratings'}`
    }

    return `${rate} ${canVote ? ' •' : ''}`
  }

  return (
    <div css={ratingWrapperCss}>
      <Stars
        value={roundedRate}
        color1={theme.colors.gray100}
        edit={false}
        size={size}
        count={starsCount}
        half
      />

      {!hideSummary && <span css={summaryCss}>{showSummary()}</span>}
    </div>
  )
}

RatingStars.propTypes = {
  canVote: bool,
  hideSummary: bool,
  rate: number,
  votes: number,
  size: number,
  starsCount: number,
  showVotes: bool,
}

export default RatingStars
